module.exports = __webpack_public_path__ + "static/media/mail-icon.b13629a0.svg";